import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const PublisherRegisterPage = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    firstName: '',
    lastName: '',
    publisherName: '',
    websiteUrl: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setIsSubmitting(true);

    try {
      await api.post('/auth/publisher/register', formData);
      setSuccess('Registration successful! Redirecting to login...');
      setTimeout(() => {
        navigate('/publisher/login');
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderInput = (name, label, type = 'text', required = true) => (
    <div>
      <label htmlFor={name} className="block text-sm font-medium text-wp-muted mb-1">{label}</label>
      <input
        type={type}
        id={name}
        name={name}
        value={formData[name]}
        onChange={handleChange}
        required={required}
        className="block w-full bg-wp-bg text-white placeholder-wp-muted px-3 py-2 border border-wp-border rounded-lg focus:outline-none focus:ring-2 focus:ring-wp-accent"
      />
    </div>
  );

  return (
    <div className="max-w-2xl mx-auto mt-10 p-8 bg-wp-surface rounded-xl border border-wp-border">
      <h2 className="text-2xl font-bold text-center text-white mb-2">Create a Publisher Account</h2>
      <p className="text-center text-wp-muted mb-6">Join WallPass to monetize your content.</p>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {renderInput('firstName', 'First Name')}
          {renderInput('lastName', 'Last Name')}
        </div>
        {renderInput('email', 'Email Address', 'email')}
        {renderInput('password', 'Password', 'password')}
        <hr className="my-4 border-wp-border" />
        <h3 className="text-lg font-medium text-white">Publisher Details</h3>
        {renderInput('publisherName', 'Publisher/Brand Name')}
        {renderInput('websiteUrl', 'Website URL', 'url')}

        {error && <p className="text-wp-danger text-sm text-center">{error}</p>}
        {success && <p className="text-wp-success text-sm text-center">{success}</p>}

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full flex justify-center py-2.5 px-4 rounded-lg text-sm font-bold text-wp-bg bg-wp-accent hover:opacity-90 transition-opacity disabled:opacity-50"
        >
          {isSubmitting ? 'Registering...' : 'Create Account'}
        </button>
      </form>
    </div>
  );
};

export default PublisherRegisterPage;
